export default "__VITE_ASSET__CvxF5VK5__"